"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EProjectFormat = void 0;
exports.EProjectFormat = {
    long_metrage: "long_metrage",
    court_metrage: "court_metrage",
    serie: "serie",
    documentaire: "documentaire",
};
